import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { UserService, BaseDataService, BaseCommonComponent, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModelDataService } from 'yt-ng-framework';
import { NgbDate, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-kartica-mp-artikla-ukupno',
  templateUrl: './kartica-mp-artikla-ukupno.component.html'
})
export class KarticaMpArtiklaUkupnoComponent
  extends BaseCommonComponent
  implements OnInit {

    @Input() Parameters;
  

  Config = {}
  mainItems = []
  items;

  baseFormGroup: FormGroup = new FormGroup({
    T01StanjeArtiklaZaPeriod: new FormControl()
    , T02ProdajnaCenaArtiklaNaKrajuPeriod: new FormControl()
    , T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda: new FormControl()
    , T04VrednostLageraArtiklaNaKrajuPerioda: new FormControl()
    , T05VrednostLageraBezPdvArtiklaNaKrajuPerioda: new FormControl()
    , T06VrednostUlazaArtiklaPoNabavnojCeni: new FormControl()
    , T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni: new FormControl()
    , T08VrednostIzlazaArtiklaPoProdajnojCeni: new FormControl()
    , T09UkupnoPdvIzlazRobe: new FormControl()
    , T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv: new FormControl()
    , T11RealizacijaDoUlozenogNovca: new FormControl()
    , T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: new FormControl()
  })

  get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;

  constructor(
    protected activeModal: NgbActiveModal,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  ) {

    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
  }

  ngOnInit() {
    super.ngOnInit();

        this.baseFormGroup.patchValue({ T01StanjeArtiklaZaPeriod: this.Parameters[0].Value });
        this.baseFormGroup.patchValue({ T02ProdajnaCenaArtiklaNaKrajuPeriod: this.Parameters[1].Value });
        this.baseFormGroup.patchValue({ T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda: this.Parameters[2].Value });
        this.baseFormGroup.patchValue({ T04VrednostLageraArtiklaNaKrajuPerioda: this.Parameters[3].Value });
        this.baseFormGroup.patchValue({ T05VrednostLageraBezPdvArtiklaNaKrajuPerioda: this.Parameters[4].Value });
        this.baseFormGroup.patchValue({ T06VrednostUlazaArtiklaPoNabavnojCeni: this.Parameters[5].Value });
        this.baseFormGroup.patchValue({ T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni: this.Parameters[6].Value });
        this.baseFormGroup.patchValue({ T08VrednostIzlazaArtiklaPoProdajnojCeni: this.Parameters[7].Value });
        this.baseFormGroup.patchValue({ T09UkupnoPdvIzlazRobe: this.Parameters[8].Value });
        this.baseFormGroup.patchValue({ T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv: this.Parameters[9].Value });
        this.baseFormGroup.patchValue({ T11RealizacijaDoUlozenogNovca: this.Parameters[10].Value });
        this.baseFormGroup.patchValue({ T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: this.Parameters[11].Value });

        // this.baseFormGroup.patchValue({ T01StanjeArtiklaZaPeriod: 1 });
        // this.baseFormGroup.patchValue({ T02ProdajnaCenaArtiklaNaKrajuPeriod: 2});
        // this.baseFormGroup.patchValue({ T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda: 3});
        // this.baseFormGroup.patchValue({ T04VrednostLageraArtiklaNaKrajuPerioda: 4});
        // this.baseFormGroup.patchValue({ T05VrednostLageraBezPdvArtiklaNaKrajuPerioda: 5 });
        // this.baseFormGroup.patchValue({ T06VrednostUlazaArtiklaPoNabavnojCeni: 6 });
        // this.baseFormGroup.patchValue({ T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni: 7 });
        // this.baseFormGroup.patchValue({ T08VrednostIzlazaArtiklaPoProdajnojCeni: 8 });
        // this.baseFormGroup.patchValue({ T09UkupnoPdvIzlazRobe: 9 });
        // this.baseFormGroup.patchValue({ T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv: 10 });
        // this.baseFormGroup.patchValue({ T11RealizacijaDoUlozenogNovca: 11 });
        // this.baseFormGroup.patchValue({ T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: 12 });

  }


  Close() {
    this.activeModal.dismiss();
  }

}
